import React, { useEffect, useRef, useState } from "react";
import LOGO from "./../assets/images/vyapar_logo.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PiArrowLeftBold } from "react-icons/pi";
import { ApisService } from "../app/core/apis.service";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import { Card, Modal } from "react-bootstrap";
import { AppConfig } from "../app/config";
import { useSelector } from "react-redux";
import LoginOtp from "./login-screen";
import { GET_PRESIGNED_URL } from "../app/core/common.srvice";
import { S3Helper } from "../app/utils/s3-helper";
import { ProductView } from "../components/product-view";
import { formatDateTimeInIST } from "../components/indiaDateFormate";

export const PurchaseOrder = () => {
  const routerParams = useParams();
  const navigate = useNavigate();
  const userData = useSelector((state: any) => state.UserDataReducer);
  const [otpReference, setOtpReference] = useState("");
  const [transactionData, setTransactionData] = useState<any[]>([]);
  const fileInputRef = useRef<any>(null);
  const [show, setShow] = useState<boolean>(false);
  const [presignedUrl, setPresignedUrl] = useState<any>();
  const [buName, setBuName] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [updateStatus, setUpdateStatus] = useState<string>("");
  const [quotationList, setQuotationList] = useState<any[]>([]);

  useEffect(() => {
    loadTransaction();
  }, []);

  async function loadTransaction(): Promise<void> {
    setLoading(true);
    const decryptData: any = JSON.parse(dataDecrypt(routerParams.id as string));
    let payload = {
      filters: {
        transaction_id: decryptData.id
      }
    }
    try {
      const encryptedPayload = dataEncrypt(JSON.stringify(payload));
      const quotationData = await ApisService.getTransactionData("getQuotations", encryptedPayload || "");
      const decryptQuotationData = JSON.parse(dataDecrypt(quotationData.data.data));
      setQuotationList(decryptQuotationData);
      const res = await ApisService.getTransactionData("getById_v2", routerParams.id || "");
      const data: any = res.data.data;
      const transactionData = JSON.parse(dataDecrypt(data));
      setTransactionData(transactionData);
      const tx = transactionData[0]
      if (tx?.sender?.id === tx?.buyer?.id) {
        setBuName(tx.buyer.name);
      } else if (tx?.sender?.id === tx?.seller?.id) {
        setBuName(tx.seller.name);
      }
      setLoading(false);
      const preparedReference = dataEncrypt(JSON.stringify({ id: transactionData[0]._id, type: "purchase-order" }));
      setOtpReference(preparedReference);
      setLoading(false);
    }
    catch {
      setLoading(false);
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event: any) => {
    const file = event.target.files;
    if (file) {
      try {
        const payload = { filename: file[0].name, location: "terms" };
        const res = await GET_PRESIGNED_URL(payload);
        if (res?.data?.url) {
          const presignedUrl = res.data.url;
          if (presignedUrl) {
            await S3Helper.uploadFilesToS3BySigned(
              presignedUrl,
              file[0],
              file[0].type
            );
            const uploadedFileUrl = presignedUrl.split("?")[0];
            setPresignedUrl(uploadedFileUrl);
          } else {
            console.error(`No presigned URL found for file: ${file[0].name}`);
          }
        } else {
          console.error("Presigned URLs not found in the response.");
        }
      } catch (error) {
        console.log("Error during file upload:", error);
      }
      finally {
        event.target.value = null;
      }
    }
  };
  const handleOpenFile = (uploadedFileUrl: any) => {
    if (uploadedFileUrl) {
      window.open(uploadedFileUrl, "_blank");
    } else {
      alert("No file uploaded yet.");
    }
  };

  const getUnitPrice = (unit_price: number, quantity: number, total_amount: any) => {
    if ((quantity > 1) && (unit_price === total_amount)) {
      const unitQuantity = (unit_price / quantity);
      return unitQuantity;
    }
    else {
      return unit_price;
    }
  }

  const updateQuotation = async (status: any, quotationId: string) => {
    setUpdateStatus(status);
    let payload = {
      id: quotationId,
    }
    const encryptedData = dataEncrypt(JSON.stringify(payload));
    try {
      const api = status === "reject" ? "ignoreQuotation" : "acceptQuotation";
      const res = await ApisService.getTransactionData(api, encryptedData);
      if (res?.status === 200) {
        setShow(true);
      }
    }
    catch (error) {
    }
  }

  const closePopup = () => {
    setShow(false);
    loadTransaction();
  }

  const getTotalPrice = (products: any[]) => {
    return products?.reduce((sum, item) => sum + item.total, 0);
  };

  const quotationView = (id: any) => {
    navigate(`/purchase-order/view/${dataEncrypt(JSON.stringify({ id: id }))}`);
  }

  return (
    <div>
      {(!userData || !userData?.otp) && <LoginOtp reference={otpReference} />}
      {userData?.otp && (
        <>
          {!loading ? <div>
            <div
              className="d-flex justify-content-between px-3 py-2 align-items-center"
              style={{ backgroundColor: "#274472", color: "white" }}
            >
              <Link to={`/order/${routerParams.id}`}>
                <span>
                  <PiArrowLeftBold size={22} className="text-white" />
                </span>
              </Link>
              <span style={{ lineHeight: "0", textAlign: "center" }}>
                <h4>{transactionData[0]?.show_quotation_acceptance ? "Quotation" : "Purchase Order"}</h4>
                <div>{buName}</div>
              </span>
              <img src={LOGO} alt="" height={60} />
            </div>
            <div className="container-fluid">
              <div style={{ backgroundColor: "white", borderRadius: "3px" }}>
                {transactionData[0]?.seller?.is_offline && <div className="text-end mb-2">
                  <button className="px-4 mt-3 fs-14 rounded" onClick={handleButtonClick}>
                    {presignedUrl ? `Upload new Invoice` : `Upload Invoice`}
                  </button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  {presignedUrl && (
                    <span className="text-center ms-3">
                      <span
                        onClick={() => handleOpenFile(presignedUrl)}
                        className="primary-color cursor-pointer"
                      >
                        <ins>Show Invoice</ins>
                      </span>
                    </span>
                  )}
                </div>}
                {transactionData[0]?.quotation && transactionData[0]?.quotation?.status === "pending" ? <p className="text-center mt-2 mb-0 fs-14 text-success lh-sm"><div>Quotation for your order,</div> Please accept Quotation for {buName} to start the process</p> : <p className="text-success text-center mt-2 mb-0 fs-5">{(transactionData[0]?.seller?.id === transactionData[0]?.sender?.id) ? <span>{transactionData[0]?.quotation && transactionData[0]?.quotation?.status === "ignored" ? "Quotation Rejected" : "Quotation Accepted & Order Placed."}</span> : <span>New Order from {buName}</span>}</p>}
                {quotationList?.length > 0 ?
                  <div>
                    <div className="row mt-2">
                      {quotationList?.map((value: any, index: any) => (
                        <div className="col-md-6 col-lg-4 mb-2" key={index}>
                          <div className={`card  rounded h-100  ${value?.status === "cancelled" ? "border-danger" : value?.status === "pending" ? "border-dark" : "border-success"}`}>
                            <div className="card-body p-2  align-items-center">
                              <div className="row w-100 align-items-center">
                                <div className={value?.status === "pending" ? "col-12" : "col-8"}>
                                  <h6 className="mb-0 primary-color fs-15 fw-bold">
                                    Quotation #{value?.quotation_number}
                                  </h6>
                                  <div className="fs-14">Quotation Date : {formatDateTimeInIST(value?.created_dt)}</div>
                                  <div className="fs-14">Status : <span className={`${value?.status === "cancelled" ? "text-danger" : value?.status === "pending" ? "primary-color" : value?.status === "ignored" ? "text-danger" : "text-success"}`}>{value?.status === "ignored" ? "Rejected" : value?.status.charAt(0).toUpperCase() + value?.status.slice(1)}</span></div>
                                  {value?.status != "pending" && <div className="fs-14">{(value?.status === "cancelled" || value?.status === "ignored") ? "Rejected" : "Accepted"} Date : {formatDateTimeInIST(value?.updated_dt)}</div>}
                                </div>
                                {value?.status !== "pending" && <div className="col-4">
                                  <button className="btn btn-outline primary-border primary-color p-0 fs-14 w-100 mb-1" onClick={() => quotationView(value?._id)}>
                                    view
                                  </button>
                                </div>}
                              </div>
                              {value?.status === "pending" && <div className="row mt-2">
                                <div className="col-4">
                                  <button className="btn btn-outline primary-border primary-color p-0 fs-14 w-100 mb-1" onClick={() => quotationView(value?._id)}>
                                    view
                                  </button>
                                </div>
                                <div className="col-4">
                                  {value?.status === "pending" && (
                                    <button className="btn btn-outline-success p-0 fs-14 w-100 mb-1" onClick={() => updateQuotation("accept", value?._id)}>
                                      accept
                                    </button>
                                  )}
                                </div>
                                <div className="col-4">
                                  {value?.status === "pending" && (
                                    <button className="col-4 btn btn-outline-danger p-0 fs-14 w-100 mb-1" onClick={() => updateQuotation("reject", value?._id)}>
                                      reject
                                    </button>
                                  )}
                                </div>
                              </div>}
                            </div>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div> : <div className="row">
                    <div className="col-md-8 mt-2 mb-1">
                      {<ProductView data={transactionData[0]?.order_details && transactionData[0]?.order_details?.products} stylesData="col-md-12 mb-2" />}
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="card box-shadow rounded-4 border-0 p-3 mb-3">
                        <div className="card-body p-0">
                          <h4 className="fw-bold">Order Summary</h4>

                          {transactionData[0]?.order_details?.products?.map(
                            (productEl: any, index: number) => (
                              <div
                                className="d-flex justify-content-between align-items-center py-2 border-bottom fs-14"
                                key={index}
                              >
                                <div className="text-truncate" style={{ maxWidth: "70%" }}>
                                  {productEl?.quantity} Qty  <b>x</b> {getUnitPrice(productEl.unit_price, productEl?.quantity, productEl.total)}
                                </div>
                                <div className="fw-semibold">₹ {productEl.total}</div>
                              </div>
                            )
                          )}

                          <div className="mt-2 border-bottom fs-16">
                            <div className="d-flex justify-content-between fw-bold pb-2">
                              <span>Total</span>
                              <span>₹ {getTotalPrice(transactionData[0]?.order_details?.products)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mb-2">
                        <Link to={`/order/${routerParams.id}`}>
                          <button className="action-btn w-100 fs-14 py-1">Track All Steps of This Transaction</button>
                        </Link>
                      </div>
                    </div>
                  </div>}
              </div>

            </div>
          </div> : <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="spinner-border text-secondary" role="status"></div>
          </div>}
        </>
      )}
      <Modal className="box-shadow" onHide={() => closePopup()} show={show} centered>
        <Modal.Body>
          <div className="text-center fs-6 fw-bold mb-2">{updateStatus === "reject" ? "Quotation rejected successfully. No order has been created." : "Quotation accepted successfully. Your order has been placed."}</div>
          <div className="text-center"><button className="px-3 py-1 rounded-3" onClick={() => closePopup()}>Ok</button></div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
